import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, vModelDynamic as _vModelDynamic, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    class: "card border-0 shadow-sm h-100 overflow-hidden",
    style: { "border-radius": "20px" }
};
const _hoisted_2 = {
    key: 0,
    class: "position-absolute end-0 top-0 mt-3 me-3 badge rounded-pill bg-success-subtle text-success py-2 px-3 animate__animated animate__fadeInRight"
};
const _hoisted_3 = { class: "card-body p-4 d-flex flex-column" };
const _hoisted_4 = { class: "d-flex align-items-center mb-4" };
const _hoisted_5 = { class: "fw-bold mb-0 text-dark" };
const _hoisted_6 = {
    class: "text-secondary small mb-4 lh-base",
    style: { "height": "40px", "overflow": "hidden" }
};
const _hoisted_7 = { class: "config-form" };
const _hoisted_8 = { class: "form-check form-switch mb-4" };
const _hoisted_9 = { class: "form-check form-switch mb-4" };
const _hoisted_10 = {
    key: 0,
    class: "row g-3 mb-4 animate__animated animate__fadeIn"
};
const _hoisted_11 = { class: "col-12" };
const _hoisted_12 = { class: "col-12" };
const _hoisted_13 = { class: "col-12" };
const _hoisted_14 = { class: "input-group" };
const _hoisted_15 = ["type"];
const _hoisted_16 = {
    key: 1,
    class: "col-12"
};
const _hoisted_17 = { class: "mt-auto pt-3 d-flex gap-2" };
const _hoisted_18 = ["disabled"];
const _hoisted_19 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
const _hoisted_20 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.localIntegration.isEnabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[9] || (_cache[9] = [
                    _createElementVNode("i", { class: "flaticon-circular-label me-1 fs-12" }, null, -1),
                    _createTextVNode(" Connecté ", -1)
                ]))]))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", {
                    class: "rounded-3 p-3 me-3 d-flex align-items-center justify-content-center text-white shadow-sm",
                    style: _normalizeStyle({ backgroundColor: _ctx.color, width: '60px', height: '60px' })
                }, [
                    _createElementVNode("i", {
                        class: _normalizeClass([_ctx.iconClass, 'fs-3'])
                    }, null, 2)
                ], 4),
                _createElementVNode("div", null, [
                    _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.name), 1),
                    _cache[10] || (_cache[10] = _createElementVNode("span", { class: "text-muted small" }, "Suisse Integration", -1))
                ])
            ]),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.description), 1),
            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "divider border-bottom mb-4 opacity-50" }, null, -1)),
            _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                    _withDirectives(_createElementVNode("input", {
                        class: "form-check-input shadow-none cursor-pointer",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.localIntegration.isEnabled) = $event)),
                        id: "activationSwitch"
                    }, null, 512), [
                        [_vModelCheckbox, _ctx.localIntegration.isEnabled]
                    ]),
                    _cache[11] || (_cache[11] = _createElementVNode("label", {
                        class: "form-check-label fw-bold small cursor-pointer",
                        for: "activationSwitch"
                    }, " Activer l'intégration ", -1))
                ]),
                _createElementVNode("div", _hoisted_9, [
                    _withDirectives(_createElementVNode("input", {
                        class: "form-check-input shadow-none cursor-pointer",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.localIntegration.delegateDelivery) = $event)),
                        id: "deliverySwitch"
                    }, null, 512), [
                        [_vModelCheckbox, _ctx.localIntegration.delegateDelivery]
                    ]),
                    _cache[12] || (_cache[12] = _createElementVNode("label", {
                        class: "form-check-label fw-bold small cursor-pointer",
                        for: "deliverySwitch"
                    }, [
                        _createTextVNode(" Déléguer la livraison à la plateforme "),
                        _createElementVNode("i", {
                            class: "flaticon-info ms-1 text-muted small",
                            title: "Si activé, Uber/JustEat gère ses propres chauffeurs par défaut."
                        })
                    ], -1))
                ]),
                (_ctx.localIntegration.isEnabled)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                            _cache[13] || (_cache[13] = _createElementVNode("label", { class: "form-label small fw-bold text-muted mb-1" }, "Store ID (UUID)", -1)),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.localIntegration.config.storeId) = $event)),
                                type: "text",
                                class: "form-control bg-light border-0 shadow-none py-2",
                                placeholder: "ex: 123e4567-e89b-..."
                            }, null, 512), [
                                [_vModelText, _ctx.localIntegration.config.storeId]
                            ])
                        ]),
                        (_ctx.platform === 'UBEREATS')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("div", _hoisted_12, [
                                    _cache[14] || (_cache[14] = _createElementVNode("label", { class: "form-label small fw-bold text-muted mb-1" }, "Client ID", -1)),
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.localIntegration.config.clientId) = $event)),
                                        type: "text",
                                        class: "form-control bg-light border-0 shadow-none py-2"
                                    }, null, 512), [
                                        [_vModelText, _ctx.localIntegration.config.clientId]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_13, [
                                    _cache[15] || (_cache[15] = _createElementVNode("label", { class: "form-label small fw-bold text-muted mb-1" }, "Client Secret", -1)),
                                    _createElementVNode("div", _hoisted_14, [
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.localIntegration.config.clientSecret) = $event)),
                                            type: _ctx.showSecret ? 'text' : 'password',
                                            class: "form-control bg-light border-0 shadow-none py-2"
                                        }, null, 8, _hoisted_15), [
                                            [_vModelDynamic, _ctx.localIntegration.config.clientSecret]
                                        ]),
                                        _createElementVNode("button", {
                                            class: "btn btn-light bg-light border-0",
                                            onClick: _cache[5] || (_cache[5] = ($event) => (_ctx.showSecret = !_ctx.showSecret))
                                        }, [
                                            _createElementVNode("i", {
                                                class: _normalizeClass(_ctx.showSecret ? 'flaticon-visibility-off' : 'flaticon-eye')
                                            }, null, 2)
                                        ])
                                    ])
                                ])
                            ], 64))
                            : _createCommentVNode("", true),
                        (_ctx.platform === 'JUSTEAT')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                _cache[16] || (_cache[16] = _createElementVNode("label", { class: "form-label small fw-bold text-muted mb-1" }, "Clé API (Token)", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.localIntegration.config.apiKey) = $event)),
                                    type: "text",
                                    class: "form-control bg-light border-0 shadow-none py-2"
                                }, null, 512), [
                                    [_vModelText, _ctx.localIntegration.config.apiKey]
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_17, [
                _createElementVNode("button", {
                    onClick: _cache[7] || (_cache[7] =
                        //@ts-ignore
                        (...args) => (_ctx.handleSave && _ctx.handleSave(...args))),
                    class: "btn btn-dark flex-grow-1 py-3 fw-bold rounded-3 shadow-none border-0",
                    disabled: _ctx.saving,
                    style: _normalizeStyle({ backgroundColor: _ctx.color })
                }, [
                    (_ctx.saving)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_19))
                        : _createCommentVNode("", true),
                    _cache[17] || (_cache[17] = _createTextVNode(" Enregistrer ", -1))
                ], 12, _hoisted_18),
                (_ctx.localIntegration.isEnabled)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[8] || (_cache[8] =
                            //@ts-ignore
                            (...args) => (_ctx.handlePing && _ctx.handlePing(...args))),
                        class: "btn btn-outline-secondary py-3 px-3 fw-bold rounded-3 shadow-none border-1",
                        title: "Tester la connexion",
                        disabled: _ctx.saving || !_ctx.localIntegration.config.storeId
                    }, [...(_cache[18] || (_cache[18] = [
                            _createElementVNode("i", { class: "flaticon-refresh" }, null, -1)
                        ]))], 8, _hoisted_20))
                    : _createCommentVNode("", true)
            ])
        ])
    ]));
}
